module.exports = __webpack_public_path__ + "c43470f2c8447feaf6e5c878fc813793.svg";